<div class="-mx-2">
  <div class="flex gap-x-2">
    <button (click)="abrirModalNuevoChat()" class="flex flex-1 items-center justify-center gap-x-1.5 rounded-md border border-gray-200 p-2.5 text-sm font-semibold leading-6 text-indigo-600 shadow-xs c-pointer hover:border-indigo-400 hover:bg-indigo-50 focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600" title="{{'Nuevo chat' | translate}}"
            type="button">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
           class="h-5 w-5" stroke="currentColor" stroke-width="1.8">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15"/>
      </svg>
      {{'Nuevo chat' | translate}}
    </button>
    <button (click)="abrirModalNuevaCarpeta()" aria-label="{{'Nueva carpeta' | translate}}" class="flex shrink-0 items-center justify-center rounded-md border border-gray-200 p-2.5 text-indigo-600 shadow-xs c-pointer hover:border-indigo-400 hover:bg-indigo-50 focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            title="{{'Nueva carpeta' | translate}}"
            type="button">
      <svg class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"
           xmlns="http://www.w3.org/2000/svg">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 10.5v6m3-3H9m4.06-7.19-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z" />
      </svg>
    </button>
  </div>
  <button (click)="navegarHiloConversaciones()" class="mt-2 flex w-full items-center gap-x-2 rounded-md px-2.5 py-2 text-sm leading-6 text-gray-600 c-pointer hover:bg-gray-50 hover:text-gray-900 focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600" title="{{'Buscar conversaciones' | translate}}"
          type="button">
    <svg class="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"
         xmlns="http://www.w3.org/2000/svg">
      <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    {{ 'Buscar conversaciones' | translate }}
  </button>
  <app-carpetas #carpetasComponent
                [esDispositivoMovil]="_esDispositivoMovil">
  </app-carpetas>
</div>
